import { gql } from '@apollo/client';

export const referralNotificationUnreadCountQuery = gql`
  query ReferralNotificationUnreadCount {
    referralNotificationUnreadCountQuery {
      count
    }
  }
`;

export const paginationReferralNotificationQuery = gql`
  query PaginationReferralNotification($page: Int, $perPage: Int) {
    paginationReferralNotificationQuery(page: $page, perPage: $perPage) {
      items {
        _id
        type
        title
        message
        isRead
        readAt
        createdAt
        data {
          company
          partner
          partnerName
          lead
          leadName
          leadVisibleId
          manager
          managerName
          bonusRequest
          bonusAmount
          currency
          contactDate
          actionUrl
        }
      }
      pageInfo {
        currentPage
        perPage
        itemCount
        pageCount
        hasPreviousPage
        hasNextPage
      }
    }
  }
`;

export const markReferralNotificationAsReadMutation = gql`
  mutation MarkReferralNotificationAsRead($_id: MongoID!) {
    markReferralNotificationAsReadMutation(_id: $_id) {
      status
      modifiedCount
    }
  }
`;

export const markReferralNotificationsPageAsReadMutation = gql`
  mutation MarkReferralNotificationsPageAsRead($ids: [MongoID!]) {
    markReferralNotificationsPageAsReadMutation(ids: $ids) {
      status
      modifiedCount
    }
  }
`;

export const markAllReferralNotificationsAsReadMutation = gql`
  mutation MarkAllReferralNotificationsAsRead {
    markAllReferralNotificationsAsReadMutation {
      status
      modifiedCount
    }
  }
`;

export const ensureDueReferralNotificationsMutation = gql`
  mutation EnsureDueReferralNotifications($managerId: MongoID) {
    ensureDueReferralNotificationsMutation(managerId: $managerId) {
      status
      modifiedCount
    }
  }
`;
